import COSInvoiceContainer from "./COSInvoicePreview.container";

export default COSInvoiceContainer;
